import pulseConfig from "@/pulsex.config";
import { MangoXImage } from "@pulsex/ui";
import { cn } from "@pulsex/utils";

type ImageProps = {
  data: any;
  cropSize?: string;
  className?: string;
  imageClassName?: string;
  needsMediaURL?: boolean;
  resolution?: number;
  priority?: boolean;
};

interface ImageSize {
  width: number;
  height: number;
  paddingTop: any;
}
const ImageUI = ({
  data,
  className,
  cropSize = "medium",
  needsMediaURL = false,
  imageClassName,
  resolution,
  priority,
}: ImageProps) => {
  if (data?.image && data?.image === pulseConfig.MEDIA_URL) return;
  return (
    <MangoXImage
      config={pulseConfig}
      data={data}
      className={cn(className)}
      ImageElementclassName={cn("", imageClassName)}
      cropSize={cropSize}
      needsMediaURL={needsMediaURL}
      resolution={resolution}
      priority={priority}
      enablePictureTag={true}
      // onLoad={(e: any) => {
      //   e.currentTarget.classList.add("animate-fadeInOneSec");
      //   e.currentTarget.classList.remove("opacity-35");
      // }}
    />
  );
};

export default ImageUI;
